import { type FC } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { DialogHeader } from "@/shared/components";

interface SendBroadcastConfirmProps {
  /** Оценка числа адресатов (зрители + контакты); null, если её нет. */
  count: number | null;
  scheduled: boolean;
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Последнее подтверждение перед отправкой: после начала отменить нельзя.
 * Разметка как у ConfirmDialog, но с переведёнными кнопками.
 */
export const SendBroadcastConfirm: FC<SendBroadcastConfirmProps> = ({
  count,
  scheduled,
  loading,
  onCancel,
  onConfirm,
}) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open
      onClose={loading ? undefined : onCancel}
      maxWidth="xs"
      fullWidth
    >
      <DialogHeader
        title={t("broadcasts.send.confirmTitle")}
        loading={loading}
        onClose={loading ? undefined : onCancel}
      />
      <DialogContent>
        <DialogContentText>
          {count === null
            ? t("broadcasts.send.confirmNoEstimate")
            : t("broadcasts.send.confirm", { count })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onCancel}
          color="inherit"
          variant="outlined"
          disabled={loading}
        >
          {t("broadcasts.send.back")}
        </Button>
        <Button
          variant="contained"
          disableElevation
          onClick={onConfirm}
          disabled={loading}
        >
          {scheduled
            ? t("broadcasts.actions.schedule")
            : t("broadcasts.actions.send")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
